import { mockSuppliers } from "./mock-data";
import { Supplier } from "../../../interfaces/pharmacy";

let suppliers = [...mockSuppliers];

const pharmacySuppliersApi = {
  getSuppliers: async (): Promise<{ result: string; content: Supplier[] }> => {
    return Promise.resolve({ result: "success", content: suppliers });
  },
  addSupplier: async (
    newSupplier: Omit<Supplier, "id">,
  ): Promise<{ result: string; content: Supplier }> => {
    const id = `SUP-${String(suppliers.length + 1).padStart(3, "0")}`;
    const supplier: Supplier = { id, ...newSupplier };
    suppliers.push(supplier);
    return Promise.resolve({ result: "success", content: supplier });
  },
  updateSupplier: async (
    updatedSupplier: Supplier,
  ): Promise<{ result: string; content: Supplier }> => {
    suppliers = suppliers.map((s) =>
      s.id === updatedSupplier.id ? updatedSupplier : s,
    );
    return Promise.resolve({ result: "success", content: updatedSupplier });
  },
  deleteSupplier: async (
    id: string,
  ): Promise<{ result: string; content?: null }> => {
    suppliers = suppliers.filter((s) => s.id !== id);
    return Promise.resolve({ result: "success", content: null });
  },
};

export default pharmacySuppliersApi; 